import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { List } from './favorite-list.model';
import { environment } from '../../../environments/environment';
import { Order } from '../order-new/order.model';
import { Product } from 'app/shared/product.model';

@Injectable()
export class OrderService {
    apiUrl = environment.apiUrl;
    selectedOrder: any;
    editingOrder = <Order>{};
    public favoriteLists;
    constructor(private http: HttpClient) {}

    getOrderById(id) {
        const params = new URLSearchParams();
        params.set('id', id);

        this.http.post(this.apiUrl + '', {
            search: params
        });
    }

    newOrder(order): Observable<any> {
        return this.http.post(this.apiUrl + '/cp/order/new', order).do(res => {
            // this.favoriteLists = res;
        });
    }

    updateOrder(): Observable<any> {
        return this.http.put(this.apiUrl + '/cp/order/update', this.editingOrder);
    }

    public getFavoritesForUser(role) {
        // this.favoriteLists = JSON.parse(localStorage.getItem('fl'));
        let index;
        if (this.favoriteLists) {
            return Observable.of(this.favoriteLists).do(res => {
                this.favoriteLists = res;
            });
        } else {
            if (role.constructor === Array) {
                index = role.indexOf('Internbruker');
                role = role[index];
            }
            // const index = role.indexOf('Internbruker');
            return this.http.get(this.apiUrl + '/cp/lists/getListsForUser/' + role).do(res => {
                this.favoriteLists = res;
                //   localStorage.setItem('fl', JSON.stringify(this.favoriteLists));
            });
        }
    }

    newFavoriteList(list: List): Observable<List> {
        // localStorage.removeItem('fl');
        this.favoriteLists = undefined;
        return this.http.post<List>(this.apiUrl + '/cp/lists/new', list);
    }

    addToFavoriteList(listId, products): Observable<any> {
        const obj = {};
        // tslint:disable-next-line:forin
        for (const i in products) {
            obj[i] = products[i];
        }
        return this.http.post<Product>(this.apiUrl + '/cp/lists/' + listId + '/addProducts', obj);
    }

    deleteFavoriteList(id) {
        // localStorage.removeItem('fl');
        this.favoriteLists = undefined;
        return this.http.delete(this.apiUrl + '/cp/lists/delete/' + id);
    }

    changeListPermission(id) {
        this.favoriteLists = undefined;
        return this.http.put(this.apiUrl + '/cp/lists/changePermission', {
            id: id
        });
    }

    deleteFavoriteListProduct(id) {
        // localStorage.removeItem('fl');
        this.favoriteLists = undefined;
        return this.http.delete(this.apiUrl + '/cp/lists/deleteProduct/' + id);
    }

    checkCaseID(id) {
        return this.http.get(this.apiUrl + '/cp/netadmin/case/' + id);
    }

    //   update(prod: string, antall: Subject<number>) {
    //     // tslint:disable-next-line:no-shadowed-variable
    //     return antall
    //       .debounceTime(2000)
    //       .distinctUntilChanged()
    //       .switchMap(antall => this.updateProductQuantityForList(prod, antall));
    //   }

    //   updateProductQuantityForList(id, quantity): Observable<any> {
    //     return this.http.put(this.apiUrl + '/cp/lists/updateQuantity/' + id, {
    //       antall: quantity
    //     });
    //   }
}



// WEBPACK FOOTER //
// ./src/app/order/shared/order.service.ts